// dependend fields in order process (stammdaten inland / ausland usw)

function residencyOnOff(
    residencyArt: HTMLElement | null,
    allResidencyArtSelect: HTMLFormElement | null | undefined,
    residencyExpiry: HTMLFormElement | null,
    allResidencyExpiryInputs: NodeListOf<HTMLInputElement> | undefined,
) {
    if (residencyArt) {
        residencyArt.style.display = "none";
        if (allResidencyArtSelect) {
            allResidencyArtSelect.required = false;
        }
    }
    if (residencyExpiry) {
        residencyExpiry.style.display = "none";
        if (allResidencyExpiryInputs && allResidencyExpiryInputs.length > 0) {
            allResidencyExpiryInputs.forEach((input) => {
                input.value = "";
                input.required = false;
            });
        }
    }
}

function radioContractStart(field: HTMLFormElement) {
    const startOfContract = document.querySelector<HTMLElement>(
        '[data-show-dependency="start-of-contract"]',
    );
    const dateInput = startOfContract?.querySelector<HTMLFormElement>(
        "#start_of_contract_datepicker",
    );
    const startOfContractHiddenField = document.querySelector<HTMLFormElement>(
        "#start-of-contract-hidden",
    );

    if (field.value === "date" && field.checked === true) {
        if (startOfContract) {
            startOfContract.style.display = "block";
            if (startOfContractHiddenField) {
                startOfContractHiddenField.value = dateInput?.value;
            }
            if (dateInput) {
                dateInput.required = true;
            }
        }
    }
    if (field.value === "direct" && field.checked === true) {
        if (startOfContract) {
            startOfContract.style.display = "none";
            if (startOfContractHiddenField) {
                startOfContractHiddenField.value = "direct";
            }
            if (dateInput) {
                dateInput.required = false;
            }
        }
    }
}
function radioPhonenumberPortierung(field: HTMLFormElement) {
    const phonenumberPortierung = document.querySelector<HTMLElement>(
        '[data-show-dependency="phonenumber-portierung"]',
    );
    const phonenumberPortierungHiddenField =
        document.querySelector<HTMLFormElement>(
            "#phonenumber-portierung-hidden",
        );

    if (!phonenumberPortierung) {
        return;
    }

    if (field.value === "1" && field.checked === true) {
        if (phonenumberPortierung) {
            phonenumberPortierung.style.display = "block";
            if (phonenumberPortierungHiddenField) {
                phonenumberPortierungHiddenField.value = field.value;
            }

            const allInputFields =
                phonenumberPortierung.querySelectorAll<HTMLFormElement>(
                    "sl-select, input",
                );
            if (allInputFields.length < 1) {
                return;
            }
            allInputFields.forEach((field) => {
                field.setAttribute("required", "");
            });
        }
    }
    if (field.value === "0" && field.checked === true) {
        if (phonenumberPortierung) {
            phonenumberPortierung.style.display = "none";
            if (phonenumberPortierungHiddenField) {
                phonenumberPortierungHiddenField.value = field.value;
            }

            const allInputFields =
                phonenumberPortierung.querySelectorAll<HTMLFormElement>(
                    "sl-select, input",
                );
            if (allInputFields.length < 1) {
                return;
            }
            allInputFields.forEach((field) => {
                field.removeAttribute("required");
            });
        }
    }
}
function radioResidency(field: HTMLFormElement, select: HTMLFormElement) {
    let inland: boolean = false;
    const options = select.querySelectorAll<HTMLFormElement>("option");
    options.forEach((option: HTMLFormElement) => {
        if (option.inland === "0" && option.selected === true) {
            inland = true;
        }
    });

    const residencyArt = document.querySelector<HTMLElement>(
        '[data-show-dependency="residency-art"]',
    );
    const allResidencyArtSelect = residencyArt?.querySelector("select") as
        | HTMLFormElement
        | null
        | undefined;
    const residencyExpiry = document.querySelector(
        '[data-show-dependency="residency-permit-expiry"]',
    ) as HTMLFormElement | null;
    const allResidencyExpiryInputs = residencyExpiry?.querySelector("input") as
        | NodeListOf<HTMLInputElement>
        | undefined;

    if (inland) {
        residencyOnOff(
            residencyArt,
            allResidencyArtSelect,
            residencyExpiry,
            allResidencyExpiryInputs,
        );
    } else {
        if (field.value === "1" && field.checked === true) {
            if (residencyArt) {
                residencyArt.style.display = "block";
                if (allResidencyArtSelect) {
                    allResidencyArtSelect.required = true;
                }
            }
            if (residencyExpiry) {
                residencyExpiry.style.display = "block";
                if (
                    allResidencyExpiryInputs &&
                    allResidencyExpiryInputs.length > 0
                ) {
                    allResidencyExpiryInputs.forEach((input) => {
                        input.required = true;
                    });
                }
            }
        }
        if (field.value === "0" && field.checked === true) {
            residencyOnOff(
                residencyArt,
                allResidencyArtSelect,
                residencyExpiry,
                allResidencyExpiryInputs,
            );
        }
    }
}

function setSelectField(
    select: HTMLFormElement,
    selector: string,
    showElement: string = "",
) {
    const activeOption = select.querySelector<HTMLFormElement>(
        `[value="${select.value}"]`,
    );

    if (activeOption) {
        const toShow = document.querySelector<HTMLElement>(
            `[data-show-dependency="${showElement}"]`,
        );
        const toShowInputs = toShow?.querySelectorAll("input");
        const inland = activeOption.dataset.inland;
        const toDisplay = document.querySelector<HTMLFormElement>(selector);

        if (toShow) {
            if (inland === "0") {
                toShow.style.display = "block";
                toShowInputs?.forEach((input) => {
                    input.required = true;
                });
            } else {
                toShow.style.display = "none";
                toShowInputs?.forEach((input) => {
                    input.required = false;
                });
            }
        }

        if (toDisplay) {
            if (inland === "1") {
                if (toDisplay.value === "2") {
                    toDisplay.value = "3";
                }
            } else {
                if (toDisplay.value !== "2") {
                    toDisplay.value = "2";
                }
            }

            for (let i = 1; i < toDisplay.children.length; i++) {
                const option = toDisplay.children[i] as HTMLFormElement;
                if (inland === "1" && option.dataset.inland === "1") {
                    option.style.display = "block";
                } else if (inland === "0" && option.dataset.inland === "0") {
                    option.style.display = "block";
                } else {
                    option.style.display = "none";
                }
            }
        }
    }
}

export function dependendFields() {
    // write custom date into hidden field
    const startOfContractField = document.querySelector<HTMLFormElement>(
        "#start_of_contract_datepicker",
    );
    if (startOfContractField) {
        const startOfContractHiddenField =
            document.querySelector<HTMLFormElement>(
                "#start-of-contract-hidden",
            );
        startOfContractField.addEventListener("changeDate", () => {
            if (startOfContractHiddenField) {
                startOfContractHiddenField.value = startOfContractField.value;
            }
        });
    }

    // for checkout form, choose id type and get residency permit field
    const contractStartSelects = document.querySelectorAll<HTMLFormElement>(
        '[data-show-dependency="contract-start-checkbox"]',
    );
    if (contractStartSelects.length > 0) {
        contractStartSelects.forEach((checkbox: HTMLFormElement) => {
            document.addEventListener("DOMContentLoaded", function () {
                radioContractStart(checkbox);
            });
            checkbox.addEventListener("change", () => {
                radioContractStart(checkbox);
            });
        });
    }

    // for checkout form, choose phonenumber portierung yes or no
    const phonenumberPortierungSelects =
        document.querySelectorAll<HTMLFormElement>(
            '[data-show-dependency="phonenumber-portierung-checkbox"]',
        );
    if (phonenumberPortierungSelects.length > 0) {
        phonenumberPortierungSelects.forEach((checkbox: HTMLFormElement) => {
            document.addEventListener("DOMContentLoaded", function () {
                radioPhonenumberPortierung(checkbox);
            });
            checkbox.addEventListener("change", () => {
                radioPhonenumberPortierung(checkbox);
            });
        });
    }

    // for checkout form, choose yes for residency permit and get residency-art & residency-permit-expiry
    const residencyCheckbox = document.querySelectorAll<HTMLFormElement>(
        '[data-show-dependency="residency-checkbox"]',
    );
    const select = document.querySelector<HTMLFormElement>(
        '[data-select-id="nationaliyid"]',
    );

    if (residencyCheckbox.length > 0) {
        residencyCheckbox.forEach((checkbox: HTMLFormElement) => {
            document.addEventListener("DOMContentLoaded", function () {
                if (select) {
                    radioResidency(checkbox, select);
                }
            });
            checkbox.addEventListener("change", () => {
                if (select) {
                    radioResidency(checkbox, select);
                }
            });
        });
    }

    // for checkout form, choose nationality and set id (ausweisart) accordingly
    if (select) {
        document.addEventListener("DOMContentLoaded", function () {
            setSelectField(
                select,
                '[data-select-id="idtypeid"]',
                "residency-permit",
            );
            residencyCheckbox.forEach((checkbox: HTMLFormElement) => {
                radioResidency(checkbox, select);
            });
        });
        select.addEventListener("sl-change", (event) => {
            const target = event.target as HTMLFormElement;
            setSelectField(
                target,
                '[data-select-id="idtypeid"]',
                "residency-permit",
            );
            residencyCheckbox.forEach((checkbox: HTMLFormElement) => {
                radioResidency(checkbox, select);
            });
        });
    }
}
